import z from "zod";

import { ErrorClassification } from "../../../sentry/classification";
import type { ErrorDetails } from "../domain";

const bouncieErrorTypeValues = [
  "UNHANDLED_EVENT_TYPE",
  "MALFORMED_PAYLOAD",
  "MISSING_EVENT_TIMESTAMP",
  "DEVICE_ASSIGNEE_OUTSIDE_ORGANIZATION",
] as const;
const bouncieErrorTypeSchema = z.enum(bouncieErrorTypeValues);
const BouncieErrorType = bouncieErrorTypeSchema.enum;
type BouncieErrorType = z.infer<typeof bouncieErrorTypeSchema>;

export type BouncieErrors =
  | { errorType: typeof BouncieErrorType.UNHANDLED_EVENT_TYPE; data: { eventType: string } }
  | { errorType: typeof BouncieErrorType.MALFORMED_PAYLOAD; data: { reason: string } }
  | { errorType: typeof BouncieErrorType.MISSING_EVENT_TIMESTAMP; data: { eventType: string } }
  | {
      errorType: typeof BouncieErrorType.DEVICE_ASSIGNEE_OUTSIDE_ORGANIZATION;
      data: { contractorProfileId: string; personId: string };
    };

export const bouncieErrorDetails: Record<BouncieErrorType, ErrorDetails> = {
  UNHANDLED_EVENT_TYPE: {
    classification: ErrorClassification.INTEGRATION_ERROR,
    sentryDescription: "Bouncie sent an event type we do not handle yet — add it to BouncieEventType and redeploy",
  },
  MALFORMED_PAYLOAD: {
    classification: ErrorClassification.VALIDATION_ERROR,
    sentryDescription: "Bouncie webhook payload was missing required envelope fields (eventType/imei/vin)",
  },
  MISSING_EVENT_TIMESTAMP: {
    classification: ErrorClassification.VALIDATION_ERROR,
    sentryDescription: "Bouncie event had no derivable event timestamp",
  },
  DEVICE_ASSIGNEE_OUTSIDE_ORGANIZATION: {
    classification: ErrorClassification.VALIDATION_ERROR,
    sentryDescription: "Device assignment named a person outside the contractor org it claimed to act for",
  },
};
